import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

import { LABELS } from '@/constants/common/message.constants'

import { Tag } from '../Tag'

type Props = Omit<ComponentPropsWithoutRef<typeof Tag>, 'color' | 'size'>

/**
 * 必須タグ
 */
export const RequiredTag: FC<Props> = ({
  children = LABELS.REQUIRED,
  className,
  ...props
}) => {
  return (
    <Tag
      {...props}
      className={clsx(['!px-1 font-normal', className])}
      color="red"
      size="small"
    >
      {children}
    </Tag>
  )
}
